import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node,
  node: PropTypes.object,
};

const ProseMirrorBoldMark = ({ children, node }) => (
  <strong data-identifier={node?.identifier}>{children}</strong>
);

ProseMirrorBoldMark.propTypes = propTypes;

export default ProseMirrorBoldMark;
